import React, { useState, useEffect } from 'react';
import Button from '../common/Button';
import { URLS, HERO_IMAGES } from '../../data/constants';
import './Hero.css';

const Hero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setPrefersReducedMotion(mediaQuery.matches);
  }, []);

  useEffect(() => {
    if (prefersReducedMotion || HERO_IMAGES.length < 2) return;

    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % HERO_IMAGES.length);
    }, 4500);

    return () => clearInterval(interval);
  }, [prefersReducedMotion]);

  return (
    <header className="hero">
      <div className="wrap">
        <div className="hero-content">
          <span className="kicker hero-kicker">Cases · Prana Consultoria</span>
          <h1>Donos de verdade.<br />Resultados de verdade.</h1>
          <p>Não importa o tamanho nem o setor. O que muda é o dono que deixou de decidir no escuro e passou a decidir pelos números.</p>
          <div className="googlebadge">
            <div><div className="googlebadge-stars">★★★★★</div></div>
            <div><b>5,0</b> <span>· 40 avaliações no Google</span></div>
          </div>
          <br />
          <Button href="#conversar">Quero entender meus números</Button>
        </div>
        <div className="hero-img" id="heroslide">
          {HERO_IMAGES.map((image, index) => (
            <img
              key={index}
              src={image.src}
              alt={image.alt}
              className={index === currentImageIndex ? 'on' : ''}
              fetchPriority={image.priority ? 'high' : 'auto'}
              decoding="async"
            />
          ))}
          <div className="hero-dots" aria-hidden="true">
            {HERO_IMAGES.map((_, index) => (
              <i
                key={index}
                className={index === currentImageIndex ? 'on' : ''}
              />
            ))}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Hero;
